// Importing necessary libraries and components
import React from 'react';
import styled from 'styled-components/native';
import { WorkoutContainerText, WorkoutTextSubHeader, WorkoutTextHeader } from '../../styles/common-styles';

// Styles are often defined using tagged template literals
const StyledView = styled.View`
    padding: 30px;
`;

const StyledTouchableHighlight = styled.TouchableHighlight``;

const StyledWorkoutContainerText = styled(WorkoutContainerText)`
  color: #c04c97;
`;

// Main functional component
const LifeStyleRow = ({ navigation }) => {
    return (
        <StyledView>
            <WorkoutTextSubHeader style={{ marginBottom: 10 }}>
                LIFESTYLE
            </WorkoutTextSubHeader>
            <WorkoutTextHeader style={{ marginBottom: 4 }}>
                Your Lifestyle Affects your Cognitive Health
            </WorkoutTextHeader>
            <WorkoutContainerText>
                Certain health conditions and lifestyle choices play an integral part of optimizing your memory and enhancing cognitive function. Cerebrocore can help improve more aspects of your cognitive health.
            </WorkoutContainerText>
            <StyledTouchableHighlight onPress={() => {
                const url = "https://cerebrocoreusa.com/the-science/lifestyle-changes/";
                navigation.navigate('webviewgeneric', { url });
            }}>
                <StyledWorkoutContainerText>
                    Learn More
                </StyledWorkoutContainerText>
            </StyledTouchableHighlight>
        </StyledView>
    );
};

// Exports
export default LifeStyleRow;
export { StyledTouchableHighlight as LifeStyleLink, StyledView as LifestyleRowParent, StyledWorkoutContainerText as LinkText };
